import { useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { Typography } from '@mui/material';
import CustomPagination from '../../shared/utils/CustomPagination';
import { useApartmentCourses } from '../../assets/api/useApartmentApi';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import CustomDivider from '../../shared/utils/CustomDivider';
import { useRegisterStudentCoursesList } from '../../assets/api/useAdminApi';

const CoordiApartmentTable = ({ apartmentRows, isLoading }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [coursePaginationModel, setCoursePaginationModel] = useState({ page: 0, pageSize: 5 });
      const [selectedRow, setSelectedRow] = useState({});
    const { data: CourseList, isLoading: isCourseListLoading } = useRegisterStudentCoursesList({
        student_id: selectedRow?.id,
        apartment_name: selectedRow?.apartment_name
    })
    const { open, handleClickOpen, handleClose } = useDialog();
  
    const courseRows = CourseList?.data?.map((item, index) => ({
        ...item,
        id: index + 1,
    }));
    const viewApartmentCourse = (row) => {
        handleClickOpen();
        setSelectedRow(row);
    }
    const apartmentColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "First Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "lastname",
            headerName: "Last Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }, {
            field: "email",
            headerName: "Email",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }, {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }, {
            field: "child_school",
            headerName: "School",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }, {
            field: "child_grade",
            headerName: "Grade",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "age",
            headerName: "Age",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "subscription_status",
            headerName: "Subscription Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
    ];



    const CourseColumns = [
        {
            field: "id",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
        },
        {
            field: "title",
            headerName: "Course Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "location_name",
            headerName: "Location Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        // {
        //     field: "start_time",
        //     headerName: "Start Time",
        //     flex: 1.5,
        //     renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        // },
        // {
        //     field: "end_time",
        //     headerName: "End Time",
        //     flex: 1.5,
        //     renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        // }
    ];

    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={apartmentRows}
                    columns={apartmentColumn}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    onRowClick={(params) => viewApartmentCourse(params.row)}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={apartmentRows?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}

            <MainDialogBox open={open} handleClose={handleClose} width={"60%"} >
                {isCourseListLoading ? (
                    <DataGridSkeleton rowsNum={5} />
                ) : (
                    <>
                        <DataGrid
                            rows={courseRows}
                            columns={CourseColumns}
                            pagination
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[10]}
                            slots={{
                                pagination: () => (
                                    <CustomPagination
                                        paginationModel={paginationModel}
                                        setPaginationModel={setPaginationModel}
                                        totalRows={courseRows?.length || 0}
                                        pageSize={paginationModel.pageSize}
                                    />
                                ),
                            }}
                        />
                    </>

                )}


            </MainDialogBox>
        </>
    )
}

export default CoordiApartmentTable